import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import type { GetMainMenuItemsParams, MenuItemDef } from "ag-grid-enterprise";
import { renderToStaticMarkup } from "react-dom/server";

const SORT_ASCENDING_ICON = renderToStaticMarkup(
  <ArrowUpOutlined className="text-black text-opacity-90" />
);
const SORT_DESCENDING_ICON = renderToStaticMarkup(
  <ArrowDownOutlined className="text-black text-opacity-90" />
);

const applySort = (
  api: GetMainMenuItemsParams["api"],
  columnId: string,
  sort: "asc" | "desc"
) =>
  api.applyColumnState({
    state: [{ colId: columnId, sort }],
    defaultState: { sort: null }
  });

/**
 * Header column menu used as the AG Grid default: Sort Ascending and
 * Sort Descending only. Applied by `CiqAgGrid` unless a grid supplies its
 * own `getMainMenuItems`. Omitted when the column is not sortable.
 */
export const getHeaderSortMenuItems = (
  params: GetMainMenuItemsParams
): MenuItemDef[] => {
  const { api, column } = params;
  const columnId = column?.getColId();
  if (!column || !columnId || columnId === "ag-Grid-SelectionColumn") {
    return [];
  }

  const isSortable =
    typeof column.isSortable === "function"
      ? column.isSortable()
      : column.getColDef?.()?.sortable !== false;
  if (!isSortable) {
    return [];
  }

  return [
    {
      name: "Sort Ascending",
      icon: SORT_ASCENDING_ICON,
      action: () => applySort(api, columnId, "asc")
    },
    {
      name: "Sort Descending",
      icon: SORT_DESCENDING_ICON,
      action: () => applySort(api, columnId, "desc")
    }
  ];
};
